import styled from "styled-components";
import React from "react";

const StyledText = styled.p`
    font-family: "Nexa";
    font-style: normal;
    font-weight: 300;
    font-size: 21px;
    line-height: 29px;
`;

interface Props {
    children: React.ReactNode;
}

const Text = ({ children }: Props): React.ReactElement => {
    return <StyledText> {children} </StyledText>;
};

export default Text;
